/* Indiehouse S4: storefront search aliases (theme-level, not Search & Discovery native synonyms).
 * Never modify storefront product data, ranking settings, or the predictive-search component. */
(() => {
  'use strict';
  if (window.__ihSearchSynonyms) return;
  window.__ihSearchSynonyms = true;
  const groups = [
    {
      pattern: /\bco[-\s]?ord(?:\s+sets?)?s?\b/gi,
      query: '("co-ord set" OR "coord set" OR "co ord set" OR "co-ord" OR coord)'
    },
    { pattern: /\bkurt(?:i|a)s?\b/gi, query: '(kurti OR kurta)' },
    { pattern: /\b(?:sarees?|saris?)\b/gi, query: '(saree OR sari)' }
  ];
  const isSearchPath = path => /\/search\/?$/.test(path);

  function expand(term) {
    const value = String(term || '').trim();
    // Preserve sophisticated queries; don't interfere with manual boolean filters.
    if (!value || value.length > 120 || /[()]|\b(?:AND|OR|NOT)\b/i.test(value)) return null;
    let expanded = value;
    for (const group of groups) expanded = expanded.replace(group.pattern, group.query);
    return expanded !== value ? expanded : null;
  }

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    let path;
    try { path = new URL(form.action, location.href).pathname; } catch (_) { return; }
    if (!isSearchPath(path)) return;
    const original = input.value.trim();
    const expanded = expand(original);
    if (!expanded) return;
    let originalField = form.querySelector('input[name="ih_original"]');
    if (!originalField) {
      originalField = document.createElement('input');
      originalField.type = 'hidden';
      originalField.name = 'ih_original';
      form.appendChild(originalField);
    }
    originalField.value = original;
    input.value = expanded;
  }, true);

  function showOriginalPhrase(params) {
    const original = params.get('ih_original');
    const expanded = params.get('q');
    if (!original || !expanded) return;
    document.querySelectorAll('[data-ih-search-display]').forEach(node => {
      if (node.textContent.includes(expanded)) {
        node.textContent = node.textContent.replace(expanded, original);
      }
    });
  }

  function init() {
    if (!isSearchPath(location.pathname)) return;
    const url = new URL(location.href);
    const params = url.searchParams;
    if (params.has('ih_original')) { showOriginalPhrase(params); return; }
    const original = params.get('q');
    const expanded = expand(original);
    if (!expanded) return;
    // Direct URL / search from another component: do one URL replacement, not a redirect loop.
    params.set('q', expanded);
    params.set('ih_original', original.trim());
    location.replace(url.toString());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();